export const institutionSelect = [
  'FeSaúde'
]

export const getUnidades = [
  {
    id: 1,
    unidade: 'Diretoria Geral'
  },
  {
    id: 2,
    unidade: 'Diretoria de Administração e Finanças'
  },
  {
    id: 3,
    unidade: 'Diretoria de Atenção à Saúde'
  },
  {
    id: 4,
    unidade: 'Diretoria de Gestão do Trabalho, Ensino e Produção do Conhecimento'
  },
  {
    id: 5,
    unidade: 'Diretoria de Inovação, Tecnologia e Gestão da Informação'
  },
  {
    id: 6,
    unidade: 'CAPS Herbert de Souza'
  },
  {
    id: 7,
    unidade: 'CAPS AD III Alcenir Veras'
  },
  {
    id: 8,
    unidade: 'CAPSi Monteiro Lobato'
  },
  {
    id: 9,
    unidade: 'CAPS Casa do Largo'
  },
  {
    id: 10,
    unidade: 'Centro de Convivência e Cultura'
  },
  {
    id: 11,
    unidade: 'Unidade de Acolhimento Infantojuvenil'
  },
  {
    id: 12,
    unidade: 'SRT - São Francisco'
  },
  {
    id: 13,
    unidade: 'SRT - Charitas'
  },
  {
    id: 14,
    unidade: 'SRT - PAC'
  },
  {
    id: 15,
    unidade: 'SRT - PAC V'
  },
  {
    id: 16,
    unidade: 'SRT - Centro'
  },
  {
    id: 17,
    unidade: 'SRT - São Lourenço'
  },
  {
    id: 18,
    unidade: 'Outro'
  },
];
